import type { RaceConfig } from '../../types/config.ts';
import type { Snapshot } from '../../types/snapshots.ts';
import { TrendLines } from '../charts/TrendLines.tsx';
import { ChartTable } from '../charts/ChartTable.tsx';
import { CandidateToken } from '../common/CandidateToken.tsx';
import { candidateColor } from '../../lib/colors.ts';
import { fmtTimeOfDay } from '../../lib/time.ts';
import { fmtPercent } from '../../lib/format.ts';

/** Vote-share trend: one line per candidate over time, a legend, and a
 *  visually-hidden per-candidate data table. */
export function MarginTrend({
  race,
  snapshots,
  resolved,
}: {
  race: RaceConfig;
  snapshots: Snapshot[];
  resolved: 'dark' | 'light';
}) {
  const columns = ['Time', ...race.candidates.map((c) => c.shortName ?? c.name)];
  const rows = snapshots.map((s) => [
    fmtTimeOfDay(s.t),
    ...race.candidates.map((c) => fmtPercent(s.candidates.find((x) => x.id === c.id)?.percent ?? null)),
  ]);

  return (
    <div className="trend">
      <p className="trend__label">
        Vote share over time <span className="dim">— is the lead growing or shrinking?</span>
      </p>
      <TrendLines race={race} snapshots={snapshots} resolved={resolved} />
      <ul className="trend__legend" aria-hidden="true">
        {race.candidates.map((c) => (
          <li key={c.id}>
            <CandidateToken candidate={c} color={candidateColor(c, resolved)} />
          </li>
        ))}
      </ul>
      <ChartTable caption="Vote share over time, by refresh" columns={columns} rows={rows} />
    </div>
  );
}
